import { SxProps, Theme } from "@mui/material/styles";
import { getColors } from '../../utils';
import { COLOR_MID_GRAY } from '../../constants'
const getStyles = () => {
  return {
    layout: (isMobile: boolean) => ({
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      height: "100%"
    }),

    leftPanel: (isMobile: boolean) => ({
      display: "flex",
      flexDirection: "column" as const,
      justifyContent: "center",
      borderRight: isMobile ? "none" : getColors().border,
      width: isMobile ? "100%" : "60%",
      height: isMobile ? "100%" : "auto",
    }),

    rightPanel: (isMobile: boolean) => ({
      display: "flex",
      flexDirection: "column" as const,
      width: isMobile ? "100%" : "40%",
      height: "100%",
      overflow: "hidden",
      color: getColors().text,
    }),

    footerContainer: {
      display: "flex",
      flexDirection: "column",
      borderTop: getColors().border,
      flexShrink: 0,
    },

    buttonContainer: {
      display: "flex",
      padding: "20px 16px",
      flexDirection: "column",
      borderTop: getColors().border,
      gap: "24px",
    },

    scrollOrderContainer: {
      flex: 1,
      overflowY: "auto",
    },

    sectionContainer: {
      display: "flex",
      padding: "20px 16px",
      alignItems: "center",
      gap: "16px",
      alignSelf: "stretch",
    } as SxProps<Theme>,

    column: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "8px",
      flex: "1 0 0",
    } as SxProps<Theme>,

    row: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flexWrap: "wrap",
    } as SxProps<Theme>,

    mapContainer: (isMobile: boolean) =>
    ({
      height: "100%",
      flex: !isMobile ? 1 : undefined,
      minHeight: !isMobile ? 0 : undefined,
    } as SxProps<Theme>),

    flexColumnCenter: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    } as SxProps<Theme>,

    flexRowStart: {
      display: "flex",
      alignItems: "center",
      gap: 1,
    } as SxProps<Theme>,

    containerSx: {
      display: "flex",
      justifyContent: "space-between",
      flex: "1 0 0",
      alignSelf: "stretch",
    },

    columnSx: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
    },

    rowSx: {
      display: "flex",
      alignItems: "center",
      gap: 1,
    },

    container: {
      display: "flex",
      flexDirection: "column",
    } as SxProps<Theme>,

    section: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      alignSelf: "stretch",
    } as SxProps<Theme>,

    addressSection: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },

    addressText: {
      variant: "caption",
    } as SxProps<Theme>,


    mobileBottomBar: {
      position: "fixed",
      bottom: 20,
      left: 10,
      right: 10,
      display: "flex",
      flexDirection: "column",
      padding: '20px 16px',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '20px',
      borderRadius: "16px",
      backgroundColor: (theme) => theme.palette.background.paper,
      borderTop: getColors().border,
      zIndex: 10
    } as SxProps<Theme>,

    mobileBottomSheet: {
      position: "fixed",
      bottom: 0,
      left: 10,
      right: 10,
      bgcolor: (theme) => theme.palette.background.paper,
      borderTopLeftRadius: "16px",
      borderTopRightRadius: "16px",
      zIndex: 1000,
      border: getColors().border,
      maxHeight: '97dvh',
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
    } as SxProps<Theme>,

    mobileHandle: {
      display: "flex",
      justifyContent: "center",
      padding: '8px 0px',
      cursor: "pointer",
    } as SxProps<Theme>,

    mobileHandleBar: {
      marginLeft: 'auto',
      marginRight: '20px',
      cursor: "pointer",
      fontSize: 20,
      fontWeight: "bold",
      userSelect: "none",
    } as SxProps<Theme>,

    mobileSheetFooter: {
      p: 2,
      borderTop: getColors().border,
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    } as SxProps<Theme>,
    emergency: {
      display: 'flex',
      padding: 'var(--Spacing-Spacing-16, 16px)',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: '16px',
      alignSelf: 'stretch'
    },
    paymentBox: {
      display: "flex",
      padding: "16px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "20px",
      alignSelf: "stretch",
      borderTop: getColors().border,
    },

    capitalize: {
      textTransform: "capitalize",
    },

    paymentRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      alignSelf: "stretch",
    },

    paymentLabel: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "8px",
    },
  };
}
export default getStyles;